import React, {useEffect} from 'react';
import ConnectionComplete from "../atoms/ConnectionComplete";
import MediaWallPreselection from "../organisms/MediaWallPreselection";
import {useSelector} from "react-redux";

import MediaWallLoading from "../../independent/MediaWallLoading";
import useMsgReceiveMediaWall from "../../../hooks/core/useMsgReceiveMediaWall";
import OverlayPanel from "../../overlayPanel/OverlayPanel";


const MainComponent = () => {
  const currentVehicle = useSelector(state => state.optionWindow.currentVehicle);
  const currentNavigation = useSelector(state => state.optionWindow.currentNavigation);
  const loadingState = useSelector(state => state.intro.loadingState);
  const { iframeRef, preselectionIndex, summaryData } = useMsgReceiveMediaWall();





  useEffect(() => {
    if(currentVehicle) {
      let modelAssetRoot = currentVehicle.code ? currentVehicle.code.toLowerCase() : "";
      if(modelAssetRoot) {
        const iframeSrc = `${process.env.REACT_APP_media_wall_configurator_url}/${modelAssetRoot.toLowerCase()}/index.html?mode=tablet`;
        iframeRef.current.src = iframeSrc;
      }
    }
  },[currentVehicle]);


  return (
    <>
      {
        loadingState !== "end" ?
          !currentNavigation ? <ConnectionComplete/>
            : <MediaWallLoading/> : null
      }
      { currentNavigation.includes("collection") && <MediaWallPreselection preselectionIndex={preselectionIndex}/> }
      <OverlayPanel summaryData={summaryData}/>
      {/*<MediaWallSummary summaryData={summaryData} currentHeader={currentHeader} />*/}

      <div>


        <iframe
          ref={iframeRef}
          id={"webglFrame"}
          // src={`${process.env.REACT_APP_media_wall_configurator_url}/${assetRoot}/index.html?mode=tablet`}
          style={{width: '100%', height: '100%', position: "absolute", border: '0px'}}/>


      </div>
    </>
  )
}

export default MainComponent;
